interface iProps {
    qrcode: any
}

export default function QrCodeCadastrarStatus({ qrcode }:iProps) {
    return (
        <div style={{
            marginLeft: "30px",
            background: qrcode.inativo === 1 ? "red" : "green",
            color: "white",
            padding: "8px",
        }}>
            {
                qrcode.id_status === 1 &&
                <p>Criado ({qrcode.inativo === 1 ? 'Inativo' : 'Ativo'})</p>
            }
            {
                qrcode.id_status === 2 &&
                <p>Instalado ({qrcode.inativo === 1 ? 'Inativo' : 'Ativo'})</p>
            }
        </div>
    )
}